/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {environment} from 'src/environments/environment';
import {AppStorageService} from '../storage/app-storage.service';
import AppConstant from '../../constants/app.constant';
import {IWebexCameraOptions} from './model/IWebexConfig';
import appUtil from '../../util/app.util';
import {DevicePlatformService} from '../device-platform/device-platform.service';
import {AppEnum} from '../../constants/app.enum';

@Injectable({
  providedIn: 'root',
})
export class WebexService {
  webex: any;
  private sdkLoaded = false;
  // private webexForApp: any;

  constructor(
    private readonly appStorage: AppStorageService,
    private readonly platformSvc: DevicePlatformService
  ) {}

  loadWebexSDK(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.sdkLoaded) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'assets/webex-sdk/webex.min.js'; // Move the file to `assets/`
      script.onload = () => {
        this.sdkLoaded = true;
        resolve();
      };
      script.onerror = error => reject(error); // NOSONAR
      document.body.appendChild(script);
    });
  }

  async init(): Promise<void> {
    const redirectUri = this.getRedirectUri();
    this.webex = window.Webex?.init({
      config: {
        credentials: {
          client_id: environment.clientId,
          redirect_uri: redirectUri,
          scope: environment.scope,
        },
      },
    });
  }

  private getRedirectUri(): string {
    // Check if running on mobile (Capacitor)
    if (Capacitor.isNativePlatform()) {
      // Use custom deep link scheme for mobile apps
      return 'mschatbox://oauth/callback';
    }
    // Use web URL for web platform
    return environment.redirectUri;
  }

  async initForApp(webexToken?: string): Promise<IWebex> {
    const initConfig: Record<string, unknown> = {
      config: {
        meetings: {
          reconnection: {
            enabled: true,
          },
          enableRtx: true,
          allowMediaInLobby: true,
        },
        logger: {
          level: 'silent',
        },
      },
    };

    if (!appUtil.isEmpty(webexToken)) {
      initConfig['credentials'] = {
        access_token: webexToken,
      };
    }

    this.webex = window.Webex.init(initConfig);
    return this.webex;
  }

  getWebex(): IWebex {
    return this.webex;
  }

  isDelaerLoggedInToWebEx(): boolean {
    const webexToken = this.appStorage.getItem(AppConstant.STORAGE_KEYS.SIT_WBX_TKN);
    if (!appUtil.isEmpty(webexToken)) {
      return true;
    }
    return false;
  }

  getGuestUserToken(): string {
    // return 'MTZkZWYyY2ItYTQ3NS00YzFlLTkwNzQtZWYyZTcyOTM0MGU1ZmZhMTZiNDctZjcy_PF84_5aa87748-9b4f-4263-bbd4-6dc7838a5706';
    return this.appStorage.getItem(AppConstant.STORAGE_KEYS.SIT_G_WBX_TKN) as string;
  }

  async getDefulltAudioDevice(): Promise<InputDeviceInfo> {
    const audioInputDevices = await this.getAudioInputDevices();
    const defaultDevice = audioInputDevices?.find(
      (device: InputDeviceInfo) => device?.deviceId === 'default'
    );
    if (defaultDevice) {
      return defaultDevice;
    }
    return {} as InputDeviceInfo;
  }

  async getAudioOutputDevices(): Promise<InputDeviceInfo[]> {
    const devices = await this.webex.meetings.mediaHelpers.getDevices();
    const audioInputDevices = devices?.filter(
      (device: InputDeviceInfo) => device?.kind === 'audiooutput'
    );
    return audioInputDevices as InputDeviceInfo[];
  }

  async getAudioInputDevices(): Promise<InputDeviceInfo[]> {
    const devices = await this.webex.meetings.mediaHelpers.getDevices();
    const audioInputDevices = devices?.filter(
      (device: InputDeviceInfo) => device?.kind === 'audioinput'
    );
    return audioInputDevices as InputDeviceInfo[];
  }

  // async getVideoDevices(): Promise<InputDeviceInfo[]> {
  //   const devices = await this.webex.meetings.mediaHelpers.getDevices();
  //   const videoDevices = devices?.filter(
  //     (device: InputDeviceInfo) => device?.kind === 'audioinput'
  //   );
  //   return videoDevices as Video[];
  // }

  getDefaultCameraStreamSetting(): IWebexCameraOptions {
    return {
      video: {
        width: {ideal: 854},
        height: {ideal: 480},
        frameRate: {ideal: 15},
      },
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
      },
    };
  }

  getDeviceId(id: string): object {
    if (id === 'default') return {deviceId: id};
    else return {deviceId: {exact: id}};
  }

  async getAudioStream(deviceId = 'default'): Promise<any> {
    const audioOption = {
      echoCancellation: true,
      noiseSuppression: true,
    };
    // if (!this.ifPlatformIsNotIosOrMacOs()) {
    //   audioOption = {
    //     ...audioOption,
    //     ...this.getDeviceId(deviceId),
    //   };
    // }
    const audioStrem = await this.webex.meetings.mediaHelpers.createMicrophoneStream(audioOption);
    return audioStrem;
  }

  private ifPlatformIsNotIosOrMacOs(): boolean {
    const platform = this.platformSvc.getPlatform();
    return platform === AppEnum.PLATFORM_IOS || platform === AppEnum.PLATFORM_MACOS;
  }
}
